import React from "react";
import {BrowserRouter, Navigate, Route, Routes} from "react-router-dom";
import {ToastContainer} from "react-toastify";

import NavBar from "../components/NavBar/NavBar";
import ResponsiveMenu from "../components/ResponsiveMenu/ResponsiveMenu";
import {useRoutes} from "../hooks";

const Navigation: React.FC = () => {
  const {routes} = useRoutes();

  return (
    <div className="App">
      <BrowserRouter>
        <div className="relative">
          <NavBar />
          <ResponsiveMenu />
          {/* <ChatBot /> */}

          <Routes>
            <Route path="/*" element={<Navigate to={"/"} replace />} />
            {routes.length &&
              routes.map(({to, Element, name}) => {
                if (name === "Contact") return null;

                return (
                  <Route
                    key={name + to + Element}
                    path={to}
                    element={<Element />}
                  />
                );
              })}
          </Routes>
        </div>
      </BrowserRouter>
      <ToastContainer />
    </div>
  );
};

export default Navigation;
